module.exports = __webpack_public_path__ + "img/dark-mud-decal-16.12b8afd3.png";